RivalIQ.apps.SocialChannelMatrix.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    function createIconStack(iconClass, includeBackground) {
        let el = $('<span>')
            .addClass('fa fa-stack fa-lg');
        if (includeBackground) {
            el = el.append($('<span>').addClass('fa fa-circle fa-stack-2x text-muted-light'));
        }
        return el.append(createIcon(iconClass).addClass('fa-stack-1x'));
    }

    function createIcon(iconClass) {
        return $('<span>').addClass(`fa fa-color ${iconClass}`);
    }

    // note: &nbsp; are required, because the alignment gets slightly off w/o them

    enums.ChannelStatus = {
        present: {
            iconContent: function (is1xux, showWarning, isEditable) {
                const iconClass = isEditable ? (showWarning ? 'fa-check fa-warning' : 'fa-check fa-check-present') : 'fa-check fa-lock';
                return createIconStack(iconClass, !is1xux);
            },
            cssClass: 'x-present',
            exportCssClass: 'x-present',
            popoverTemplate: '#matrixListItemPopoverHappyTemplate'
        },
        notPresent: {
            iconContent: function (is1xux) {
                return createIconStack(is1xux ? 'fa-question fa-question-missing' : '', !is1xux);
            },
            cssClass: 'x-not-present',
            exportCssClass: 'x-not-present',
            popoverTemplate: '#matrixListItemPopoverSadTemplate'
        },
        underReview: { // TODO can go away
            iconContent: function (is1xux) {
                return createIconStack(is1xux ? 'fa-question fa-question-missing' : '', !is1xux);
            },
            cssClass: 'x-not-present',
            exportCssClass: 'x-not-present',
            popoverTemplate: '#matrixListItemPopoverSadTemplate'
        },
        hasChangeRequest: {
            iconContent: function (is1xux) {
                return createIcon('fa-circle-o-notch fa-spin x-export-hide', !is1xux);
            },
            cssClass: 'x-has-change-request',
            exportCssClass: 'x-not-present',
            popoverTemplate: '#matrixListItemPopoverHasChangeRequestTemplate'
        },
        stillFinding: {
            iconContent: function (is1xux) {
                return createIcon('fa-circle-o-notch fa-spin x-export-hide', !is1xux);
            },
            cssClass: 'x-still-finding',
            exportCssClass: 'x-not-present',
            popoverTemplate: '#matrixListItemPopoverStillFindingTemplate'
        }
    };
});
